// apps/hub-cathlab/src/store/auth.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserPermission, UserGroup } from '../../../../packages/contract/dtos';
import { initialState } from '../../../../packages/contract/interfaces';

const authSlice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    // Global state action to set user and auth data
    setGlobalState: (state, action: PayloadAction<{
      first_name: string;
      last_name: string;
      full_name: string;
      email: string;
      mobile: string | null;
      subject_id: string;
      creation_date: string | null;
      last_accessed_branch_id: number | null;
      user_groups: UserGroup[];
      user_permissions: UserPermission[];
      last_login: string;
      user_branches: string;
      // Token data
      access_token: string;
      id_token: string;
      refresh_token: string;
      expires_at: number;
      tenant_id: number;
      storefront_id: number | null;
      currency_code: string | null;
      exchange_rate: number | null;
    }>) => {
      state.globalState = action.payload;
    },
    
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    
    logout: () => {
      return initialState;
    },
  },
});

export const { setGlobalState, setLoading, logout } = authSlice.actions;
export default authSlice.reducer;




